// The identity domain's copy, owned here so every surface (mobile + desktop)
// shows identical wording. Apps merge these into their own vue-i18n instance —
// the content sits under the `authentication` namespace, matching the keys the
// identity screens address (`t('authentication.linking.…')`). Plain data: no
// vue-i18n dependency, so a non-UI consumer that never imports this pays nothing.
import enCA from './en-CA/authentication.json';
import frCA from './fr-CA/authentication.json';

// { <locale>: { authentication: { login, linking, profile } } }
export const identityMessages = {
  'en-CA': { authentication: enCA },
  'fr-CA': { authentication: frCA }
};

export default identityMessages;
